import qs from 'qs';
import { IDENTITY_TYPE } from 'common/constants/Types';
import CommonAuthnApi from 'common/http/services/AuthnApi';
import i18n from 'common/locales';
import Utils from 'common/utils';
import JSRuntime from 'common/utils/JSRuntime';
import { IIdentity } from './type';

export const ssoRedirect = async (idp: IIdentity, accountId: string) => {
  const res = await CommonAuthnApi.getSSOLoginState(accountId, idp.id);
  if (res.errCode) return;
  const stateId = m.get(res, 'state');
  const baseRedirectUrl = m.get(idp, 'settings.redirectUrl');

  const query = JSRuntime.parseLocationSearch();
  const errorQs = query.origin ? `?${qs.stringify({ origin: query.origin })}` : '';

  const params = qs.stringify({
    state: window.btoa(
      JSON.stringify({
        stateId,
        // NOTICE 给单个直接跳转的认证源使用
        cidp: window.encodeURIComponent(JSRuntime.getIdpSite(undefined, '/cidp')),
        // NOTICE 给单个直接跳转的认证源报错使用
        errorCidp: window.encodeURIComponent(JSRuntime.getIdpSite(errorQs, '/cidp/error')),
        // 钉钉需要cb地址作为跳转中转页
        cb:
          idp.uniqueName === IDENTITY_TYPE.DINGTALK
            ? _.get(idp, 'settings.callbackUrl')
            : undefined,
        redirectUrl: query.redirectUrl
          ? JSRuntime.getOAuth2RedirectUrl(query.redirectUrl, 'username')
          : undefined,
        lang: i18n.language,
      }),
    ),
    forceAuthn: query.forceAuthn ? true : undefined,
  });
  Utils.safeRedirect(`${baseRedirectUrl.replace(/\/$/, '')}?${params}`);
};
